import React from 'react'
import video from "../assets/1 -Ganga  Foundation - Mall (1).mp4"

function GangaVideoPlayer() {
     return (
        <div className="relative w-full h-screen overflow-hidden">
          {/* Background Video */}
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      );
}

export default GangaVideoPlayer
